import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import CustomCursor from "../components/common/CustomCursor";
import ScrollIndicator from "../components/common/ScrollIndicator";
import Marquee from "../components/common/Marquee";
import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Projects from "../components/sections/Projects";
import Experience from "../components/sections/Experience";
import Contact from "../components/sections/Contact";
import useNoCopy from "../hooks/useNoCopy";
import "../styles/portfolio.scss";

const PortfolioPage = () => {
  useNoCopy();
  return (
    <>
      <CustomCursor />
      <ScrollIndicator />

      <Navbar />

      <main>
        <Hero />
        <Marquee />
        <About />
        <Projects />
        <Experience />
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default PortfolioPage;
